<template>
  <div>
    <div class="dialog-decor dialog-decor-left-top"></div>
    <div class="dialog-decor dialog-decor-right-top"></div>
    <div class="dialog-decor dialog-decor-left-bottom"></div>
    <div class="dialog-decor dialog-decor-right-bottom"></div>
    <div class="dialog-decor dialog-decor-center-top"></div>
    <div class="dialog-decor dialog-decor-center-bottom"></div>
  </div>
</template>

<script>

export default {
  name: 'DecorKidDialog',
}

</script>

<style lang="scss">
.dialog-decor {
  position: absolute;
  border-radius: 50%;
  background: #fff;

  &:before,
  &:after {
    content: "";
    display: block;
    position: absolute;
    border-radius: 50%;
    background: #fff;
  }

  &-center {
    &-top {
      width: 15%;
      padding-top: 15%;
      left: 40%;
      top: -2%;
    }

    &-bottom {
      width: 15%;
      padding-top: 15%;
      left: 55%;
      bottom: -2%;
    }
  }

  &-left {
    &-top {
      width: 15%;
      padding-top: 15%;
      left: -2%;
      top: -2%;

      &:before {
        width: 300%;
        padding-top: 300%;
        top: -5%;
        left: 50%;
      }

      &:after {
        width: 200%;
        padding-top: 200%;
        top: 50%;
        left: -10%;
      }
    }
  }

  &-left {
    &-bottom {
      width: 15%;
      padding-top: 15%;
      left: -1%;
      bottom: -2%;

      &:before {
        width: 200%;
        padding-top: 200%;
        top: -170%;
        left: -20%;
      }

      &:after {
        width: 200%;
        padding-top: 200%;
        top: -90%;
        left: 100%;
      }
    }
  }

  &-right {
    &-top {
      width: 15%;
      padding-top: 15%;
      right: -2%;
      top: -2%;

      &:before {
        width: 300%;
        padding-top: 300%;
        top: -5%;
        left: -250%;
      }

      &:after {
        width: 200%;
        padding-top: 200%;
        top: 50%;
        right: -10%;
      }
    }
  }

  &-right {
    &-bottom {
      width: 15%;
      padding-top: 15%;
      right: -2%;
      bottom: -2%;

      &:before {
        width: 250%;
        padding-top: 250%;
        top: -215%;
        left: -140%;
      }

      &:after {
        width: 150%;
        padding-top: 150%;
        top: -40%;
        left: -120%;
      }
    }
  }
}
</style>
